"use client";

import React from "react";
import { FileSearch, Compass, ShieldCheck } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "Technological Optimization",
  description: "Precision-engineered digital environments designed to refine workflows and integrate advanced systems for maximum organizational performance.",
  icon: FileSearch
}, {
  title: "Strategic Advisory",
  description: "High-level technical oversight and data-driven insights that allow organizations to navigate complex business landscapes with architectural clarity.",
  icon: Compass
}, {
  title: "Infrastructure Streamlining",
  description: "Robust internal structures and scalable frameworks that serve as the versatile foundation for modern professional service delivery.",
  icon: ShieldCheck
}];
export default function CoreConsultingPillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="101323" id="advisory-pillars" className="bg-background py-24 md:py-32 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-y-16 md:gap-y-0">
          {pillars.map((pillar, i) => <div key={i} data-index={i} className="relative flex flex-col items-start px-6 md:px-10 lg:px-16 group cursor-default border border-border/10 rounded-xl transition-all duration-300 hover:border-primary/40 hover:shadow-[inset_0_0_30px_rgba(0,255,255,0.04)]">
              <pillar.icon className="size-12 mb-8 text-primary transition-colors duration-300 group-hover:text-primary/80" strokeWidth={1.5} />
              <h3 className="text-2xl font-bold tracking-tight mb-4 text-foreground font-sans">
                {pillar.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed text-lg font-sans text-left">
                {pillar.description}
              </p>

              {}
              {i < pillars.length - 1 && <div className="hidden md:block absolute right-0 top-0 bottom-0 w-px py-2">
                  <Separator orientation="vertical" className="h-full bg-border/20" />
                </div>}
              
              {}
              {i < pillars.length - 1 && <div className="block md:hidden absolute -bottom-8 left-8 right-8">
                  <Separator orientation="horizontal" className="bg-border/20" />
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}